export default __webpack_public_path__ + "fonts/icon_x_circle.svg";